module.exports = __webpack_public_path__ + "img/en_meals_guide.bdf0f0af.jpg";